/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Super_Zesty_Bulldog_FearInputs */

const en_super_zesty_bulldog_fear = /** @type {(inputs: Super_Zesty_Bulldog_FearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage reports`)
};

const de_super_zesty_bulldog_fear = /** @type {(inputs: Super_Zesty_Bulldog_FearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berichte verwalten`)
};

/**
* | output |
* | --- |
* | "Manage reports" |
*
* @param {Super_Zesty_Bulldog_FearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const super_zesty_bulldog_fear = /** @type {((inputs?: Super_Zesty_Bulldog_FearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Super_Zesty_Bulldog_FearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_super_zesty_bulldog_fear(inputs)
	return de_super_zesty_bulldog_fear(inputs)
});